import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./styles.css";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { Container, Row, Col } from "react-bootstrap";
import { Form, Input, Button, message, Alert } from "antd";
import { UserOutlined, LockOutlined, MailOutlined } from "@ant-design/icons";
import axios from "axios";
import API from "../../Config/API";
import { login } from "../../Redux/Slices/AuthSlice";
import RegisterModal from "./RegisterModal";
import style from "./style";
function LoginScreen(props) {
  const dispatch = useDispatch();
  const Auth = useSelector((state) => state.Auth);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [register, setregister] = useState(false);

  const onFinish = async (value) => {
    setLoading(true);
    let obj = {
      email: value.username,
      password: value.password,
    };
    axios
      .post(API.BASR_URL + API.LOGIN, obj, {
        headers: { "Content-Type": "application/json" },
      })
      .then(function (response) {
        setLoading(false);
        if (response.status === 200) {
          dispatch(login(response.data));
          if (response.data.active) {
            message.success("loggined successfully.");
            props.history.push("/auth/home");
          } else {
            message.error("User not verified");
          }
        }
      })
      .catch(function (error) {
        setLoading(false);
        setError(error.response.data.message);
        message.error(error.response.data.message);
      });
  };

  return (
    <div className="login-screen">
      <Container fluid className="login-container">
        <Row className="min-vh-100">
          <Col lg={6} md={6} sm={12} className="bg-Col">
            <div className="brand-section">
              <div className="brand-content">
                <div className="sahari-Login-Screen-Logo"></div>
                <div className="brand-text-container">
                  <div className="brand-tagline">
                    DISCOVER NEW WAYS TO TAKE YOUR BUSINESS FURTHER
                  </div>
                  <p className="brand-description">
                    Empower your business with innovative solutions and streamlined management tools.
                  </p>
                </div>
                <Button
                  type="primary"
                  size="large"
                  onClick={() => setregister(true)}
                  className="register-btn"
                >
                  Register Now
                </Button>
              </div>
            </div>
          </Col>
          
          <Col lg={6} md={6} sm={12} className="login-form-col">
            <div className="login-form-container">
              <div className="login-form-content">
                <div className="login-header">
                  <h2 className="login-title">Welcome Back</h2>
                  <p className="login-subtitle">Sign in to your account</p>
                </div>

                {error && (
                  <Alert
                    message={error}
                    type="error"
                    showIcon
                    className="login-error"
                    closable
                    onClose={() => setError(null)}
                  />
                )}

                <Form 
                  name="loginForm" 
                  onFinish={onFinish}
                  layout="vertical"
                  size="large"
                  className="login-form"
                >
                  <Form.Item
                    name="username"
                    label="Email / Username"
                    rules={[
                      {
                        required: true,
                        message: "Please input your email or username",
                      },
                    ]}
                  >
                    <Input 
                      placeholder="Enter your email or username"
                      prefix={<MailOutlined className="input-icon" />}
                      className="login-input"
                    />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password",
                      },
                      {
                        min: 6,
                        message: "Password must be at least 6 characters",
                      },
                    ]}
                  >
                    <Input.Password 
                      placeholder="Enter your password"
                      prefix={<LockOutlined className="input-icon" />}
                      className="login-input"
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      block
                      loading={loading}
                      className="login-btn"
                    >
                      {loading ? "Signing In..." : "Sign In"}
                    </Button>
                  </Form.Item>
                </Form>

                <div className="login-footer">
                  <p className="contact-admin">
                    Don't have an account? Please contact your administrator.
                  </p>
                  <div className="support-contact">
                    <MailOutlined /> info@sahariics.com
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      
      {register && (
        <RegisterModal visible={register} onClose={() => setregister(false)} />
      )}
    </div>
  );
}
export default LoginScreen;
